"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const moment = require("moment");
const models = require("../models/audits");
exports.models = models;
const shared_1 = require("./shared");
async function getActions(accessToken, correlationId, resourceType, resourceId, createdBefore = moment().toISOString()) {
    const getAll = async (paginationUrl) => {
        const url = paginationUrl || `${shared_1.getBaseUrl()}/v0/audits/${resourceType}/${resourceId}`;
        const request = {
            headers: shared_1.getHeaders(accessToken, correlationId),
        };
        if (!paginationUrl) {
            request.params = { createdBefore };
        }
        const response = (await axios_1.default.get(url, request)).data;
        const actions = response.items;
        if (response._links.next) {
            actions.push(...(await getAll(response._links.next.href)));
        }
        return actions;
    };
    return getAll();
}
exports.getActions = getActions;
//# sourceMappingURL=audits.v0.js.map